export const opts_local = {
  // GRIND_SELECTED_MAP: 'sawmill1_sabotage0',
};
